export default __webpack_public_path__ + "static/media/chrysler.8005a2a2.svg";